module.exports = __webpack_public_path__ + "img/en.385d3fa.svg";